import React from "react";
import ImagesConstants from "../../../constants/ImagesConstants";

const ReleaseV6 = () => {
    return (
        <div className="release_content">
            <h3>DataBook Release Note Beta_V.1.4.0</h3>
            <div className="w-100 p-2">
                <p>Released on 26 Aug 2024</p>
                <div className="py-1">
                    <p className="release-font-family">We are excited to announce the release of DataBook Version 1.4.0. This version includes several new features, enhancements, and bug fixes to improve the overall user experience and functionality.</p>
                </div>
                <div>
                    <a href="https://databook.maestro.maersk.com/" target="_blank">Get Started!</a> | <a href="https://docs.maestro.maersk.com/docs-databook/intro/" target="_blank">User Guide </a>
                </div>
            </div>
            <div className="p-2 mt-3">
                <div className="py-3">
                    <h2>New Features</h2>
                    {/* <p className="release-font-family">Discover data assets faster through an optimised search engine.</p> */}
                    <ul>
                        <li className="py-1 release-font-family"> Self-service metadata publish</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                User interface to establish connection to various databases
                            </li>
                            <li className="py-1 release-font-family">
                                Ability to publish metadata into DataBook.
                            </li>
                        </ul>
                        <li className="py-1 release-font-family">Improved accessibility </li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                Availability of Azure Active Directory group name for datasets.
                            </li>
                            <li className="py-1 release-font-family">
                                Ability to copy AAD group name.
                            </li>
                            <li className="py-1 release-font-family">
                                Utilise the AAD group name for searching dataset in Saviynt for access request.
                            </li>


                        </ul>
                        <li className="py-1 release-font-family">Portfolio & platform classification of datasets</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                Simplified dataset discovery by classification of datasets based on portfolio (ex. Transported By Maersk) in the landing page.
                            </li>
                            <li className="py-1 release-font-family">
                                Simplified dataset discovery by classification of datasets based on platform (ex. Fulfilment platform) in the landing page.
                            </li>
                            <li className="py-1 release-font-family">
                                Availability of portfolio and platform tags in individual datasets.s
                            </li>


                        </ul>
                    </ul>
                </div>
                <div className="py-3">
                    <h2>Enhancements</h2>
                    {/* <p className="release-font-family">Discover data assets faster through an optimised search engine.</p> */}
                    <ul>
                        <li className="py-1 release-font-family">Advanced and optimised search capabilities</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                Added filters for metadata attributes to refine search results.
                            </li>
                            <li className="py-1 release-font-family">
                                Simplified filters to support targeted search.
                            </li>
                            <li className="py-1 release-font-family">
                                Pre-applied filters at dataset level with flexibility to edit search criteria.
                            </li>


                        </ul>
                        <li className="py-1 release-font-family">Data Lineage Visualisation</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                Availability of lineage for targeted datasets.
                            </li>
                            <li className="py-1 release-font-family">
                                Interactive nodes to explore upstream and downstream data flow.
                            </li>
                            <li className="py-1 release-font-family">
                                Ability to export lineage flow as CSV or JSON.
                            </li>


                        </ul>
                        <li className="py-1 release-font-family">User Interface Improvements</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                Redesigned User Interface for better usability and aesthetics.
                            </li>
                            <li className="py-1 release-font-family">
                                Enhanced  interface to visualize data lineage.
                            </li>
                            <li className="py-1 release-font-family">
                                Simplified landing page and unified theming across all pages.
                            </li>


                        </ul>
                        <li className="py-1 release-font-family">Performance Optimisation</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                Faster search result across the product pages.
                            </li>
                            <li className="py-1 release-font-family">
                                Seamless availability of columns, preview and lineage for datasets.
                            </li>
                        </ul>
                        <li className="py-1 release-font-family">Stability Improvement</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                Availability of dataset preview.
                            </li>
                            <li className="py-1 release-font-family">
                                Seamless availability of columns, preview and lineage for datasets.
                            </li>
                        </ul>

                    </ul>
                </div>
                <div className="py-3">
                    <h2>Bug Fixes
                    </h2>
                    {/* <p className="release-font-family">Discover data assets faster through an optimised search engine.</p> */}
                    <ul>
                        <li className="py-1 release-font-family">Resolved issues</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                Fixed multiple error messages that used to pop-up due to user inactivity.
                            </li>



                        </ul>
                    </ul>
                </div>
                <div className="py-3">
                    <h2>
                        Feedback and Support
                    </h2>
                    {/* <p className="release-font-family">Discover data assets faster through an optimised search engine.</p> */}
                    <ul>
                        <li className="py-1 release-font-family">Resolved issues</li>
                        <ul className="py-1">
                            <li className="py-1 release-font-family">
                                We value your feedback and are committed to improving our product. If you encounter any issues or have suggestions for future releases, please contact our support team at  <a href="https://teams.microsoft.com/l/channel/19%3Aca658371337642219ac5346c77de0d9a%40thread.tacv2/DataBook?groupId=0661e0ee-d58b-4a3c-b947-ae1d91a4158f&tenantId=05d75c05-fa1a-42e7-9cf1-eb416c396f2d" target="_blank">Maestro Platform | DataBook | Microsoft Teams</a>.
                            </li>



                        </ul>
                    </ul>
                </div>
            </div>
            <div>
                <h2>Thank you for using DataBook!</h2>
            </div>

        </div>
    );
};

export default ReleaseV6;
